import * as core from '../../../../../../../core'

import { query } from './projects-table.query'

export const RESOURCE = {
  payload: {
    alias: 'projects-table',
    description: 'Table used to display and explore projects',
    name: 'Projects Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
